gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".J15-Ultra-desc .text-container").forEach((el) => {
  gsap.to(el, {
    opacity: 1,
    y: 0, // 相当于 translateY(0)
    duration: 0.5, // 控制动画时间
    ease: "power2.out",
    scrollTrigger: {
      trigger: el,
      start: "top 90%",
      end: "top 20%",
      scrub: true
    }
  });
});
document.querySelectorAll(".new_730_text_with_image .animatefadeInUp").forEach((el) => {
  gsap.to(el, {
      opacity: 1,
      y: 0, // 相当于 translateY(0)
      duration: 1, // 控制动画时间
      ease: "power2.out",
      scrollTrigger: {
          trigger: el,
          start: "top 85%",
          end: "top 84%",
          scrub: true
      }
  });
});
// document.querySelector('.product-new-730').style.overflow = 'hidden'; // 禁止滚动

// window.onload = function () {
//   document.querySelector('.product-new-730').style.overflow = ''; // 解除滚动限制
// window.scrollTo(0, 0);
// };